import { createSlice } from '@reduxjs/toolkit';
import { PhoneCodeInputNames } from '@dekafvv/sharedfrontend';

export type PhoneAnswersState = {
  [PhoneCodeInputNames.primaryPhoneNumber]: string;
  [PhoneCodeInputNames.primaryPhoneCountryCode]: string;
};

export const initialPhoneChangeState: {
  answers: {
    phoneFields: PhoneAnswersState;
  };
} = {
    answers: {
        phoneFields: {
            [PhoneCodeInputNames.primaryPhoneNumber]: '',
            [PhoneCodeInputNames.primaryPhoneCountryCode]: '',
        },
    },
};

const reducers = {
    setAnswers: (state, action) => ({
        ...state,
        answers: {
            ...state.answers,
            ...action.payload,
        },
    }),
    setDefaultInitialPhoneState: () => ({
        ...initialPhoneChangeState,
    }),
};

const changePhoneSlice = createSlice({
    name: 'changePhoneSlice',
    initialState: initialPhoneChangeState,
    reducers,
});

export default changePhoneSlice;
